import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { AssetSelectionTypeEnum } from '../../../../../models/enum/shared/asset-selection-type.enum';
import { RadioButtonInputComponent } from '../../../../../ui/form-components/radio-button-input/radio-button-input.component';
import { FormOptionLabelComponent } from '../../../../../ui/form-components/form-option-label/form-option-label.component';

@Component({
  selector: 'app-account-asset-selection-type-radio-group',
  standalone: true,
  templateUrl: './account-asset-selection-type-radio-group.component.html',
  styleUrls: ['./account-asset-selection-type-radio-group.component.scss'],
  imports: [ReactiveFormsModule, RadioButtonInputComponent, FormOptionLabelComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountAssetSelectionTypeRadioGroupComponent {
  @Input({ required: true }) control!: FormControl<AssetSelectionTypeEnum>;
  @Input() hasAnyLocked = true;
  @Input() hasAnyUnlocked = true;

  protected readonly AccountAssetSelectionTypeEnum = AssetSelectionTypeEnum;
}
